<template>
    <div>
        <div v-if="isTaker">
            <el-button
                v-if="resource.is_blankable"
                type="primary"
                size="medium"
                class="actions-button"
                @click="openModal('restart')"
            >
                Restart VM
            </el-button>
            <el-button
                v-if="resource.is_blankable"
                type="danger"
                size="medium"
                class="actions-button"
                @click="openModal('recreate')"
            >
                Recreate VM
            </el-button>
            <el-button
                v-if="isTaker"
                type="danger"
                size="medium"
                class="actions-button"
                @click="openModal('reconfigure')"
            >
                Reconfigure
            </el-button>
        </div>
        <div v-else>
            <el-button
                type="primary"
                size="medium"
                class="actions-button"
                @click="openModal('restart')"
            >
                Restart
            </el-button>
            <el-button
                type="danger"
                size="medium"
                class="actions-button"
                @click="openModal('recreate')"
            >
                Recreate
            </el-button>
        </div>
        <action-modal
            ref="confirmModal"
            @watchModelStatus="watchModelStatus"
        ></action-modal>
    </div>
</template>

<script>
import ActionModal from './action-confirm-modal.vue';
export default {

    name: 'ActionsButtons',
    components:{
        ActionModal,
    },
    props:{
        details:{
            type: Object,
            required: true,
        },
        resource:{
            type: Object,
            default: null
        },
        isTaker:{
            type: Boolean,
            default: false,
        },
        resourceIsFeed:{
            type: Boolean,
            default:false,
        },
    },
    data () {
        return {
            flowArn:'',
            flowUid:'',
            action: '',
            isVM: false,
        };
    },
    computed:{
        redudancyType(){
            if(this.details.name.charAt(0) === 'M'){
                return 'main';
            }
            return 'backup';
        },
        configurationUid(){
            if(this.details.taker_data){
                return this.details.taker_data[0].configuration_uid;
            }
            return '';
        }
    },
    methods:{
        openModal(action){
            let resource = this.resource;
            let redundancyType = this.redudancyType;
            let moduleType = this.details.type.toUpperCase();
            this.action = action;

            if(this.isTaker && this.resource.is_blankable && this.action !=='reconfigure'){
                this.isVM = true;
                moduleType = 'BLANKING_VM';
            }

            if(moduleType === 'DELIVERY'){
                this.flowArn = this.details.arn;
                this.flowUid = this.details.uid;
            }

            this.$refs.confirmModal.open(
                action,
                this.details.name,
                resource,
                redundancyType,
                moduleType,
                this.flowArn,
                this.flowUid,
                this.configurationUid,
                this.isVM,
                this.resourceIsFeed,
            );
        },
        watchModelStatus(url){
            this.$emit('watchModelStatus', {
                url: url,
                name: this.details.name,
                action: this.action,
                isVM: this.isVM
            });
        }
    }
};
</script>

<style lang="css" scoped>
    .action-button{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/ResourceActionBtn/actions-buttons.vue